import { Notification } from '@typing/global';
import { useQuery } from 'react-query';
import { QueryConfig } from '../../lib/react-query';
import { axios } from '@axios';

export const getNotifications = (userType: string, id: string): Promise<Notification[]> => {
  return axios.get(`/notification/get-user-notifications/${userType}/${id}`);
};

export const getNotificationsCount = (notificationId: string): Promise<number> => {
  return axios.get(`/notification/count/${notificationId}`).then(res => res.data);
};


export const markNotificationAsRead = (notificationId: string): Promise<Notification> => {
  return axios.put(`/notification/mark-as-read/${notificationId}`);
};

export const clearAllNotification = (): Promise<any> => {
  return axios.put(`/notification/clear-all-notifications`);
};

type QueryFnType = typeof getNotifications;

type UseNotificationsOptions = {
  userType: string;
  userId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useNotifications = ({ userType, userId, config }: UseNotificationsOptions) => {
  return useQuery<Notification[]>({
    queryKey: ['notifications', userType, userId],
    queryFn: () => getNotifications(userType, userId),
    select: (res: any) => res?.data.notifications || [],
    ...config,
  });
};
